import moment from "moment"
// month is 0 indexed, April === 3
const fiscalStartDate = moment.utc().month() >= 3
  ? moment().startOf("year").month("April").startOf("month")
  : moment().startOf("year").month("April").startOf("month").subtract(1, "years")
const fiscalEndDate = moment.utc(fiscalStartDate).add(1, "years").subtract(1, "days")

export const fiscalYearMixin = {
  data: () => ({
    fiscalYear: {
      startDate: fiscalStartDate,
      endDate: fiscalEndDate,
    }
  }),
}
